import type { OccupancyReportComponentProps } from './OccupancyReportComponent';

export const OccupancyReportComponent = {
    MountAsync: async (target: HTMLElement, props: OccupancyReportComponentProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { OccupancyReportComponent } = await import('./OccupancyReportComponent');
        return await mountReactComponentAsync(target, OccupancyReportComponent, props);
    }
};
